import { fromJS } from 'immutable';

import { ADD_TRACKED_ASSET, SET_TRACKED_ASSET_DATA } from './constants';

export function addTrackedVideo(data, callback) {
  return {
    type: ADD_TRACKED_ASSET,
    data,
    callback,
  };
}

export function setTrackedAssetData(data) {
  return {
    type: SET_TRACKED_ASSET_DATA,
    data: fromJS(data),
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/track-asset-modal/actions.js
 **/